import { Size } from '../math/size'
import { Point } from '../math/point'
import { Matrix } from '../math/matrix'

import clone from 'immutability-helper'

export class ScreenChar {
  constructor(readonly c: number, readonly fg: number = 0xFFFFFF, readonly bg: number = 0x000000) {}
}

export class ConsoleScreen {
  fg: number = 0xFFFFFF
  bg: number = 0x000000

  readonly m: Matrix<ScreenChar>

  constructor(readonly size: Size) {
    this.m = new Matrix<ScreenChar>(size, (x, y) => new ScreenChar(0))
  }

  writeAt(p: Point, s: string) {
    const chars = [...s];
    chars.forEach((s, i) => this.writeCharCode(s.charCodeAt(0), p.x + i, p.y))
  }

  writeCharCode(c: number, x: number, y: number) {
    this.m.set(x, y, new ScreenChar(c, this.fg, this.bg))
  }

  forEach(f: (sc: ScreenChar, x: number, y: number) => void) {
    this.m.forEach(f)
  }
}